import Reflux from "reflux";

var DocumentActions = Reflux.createActions([
	"new",
	"load",
	"setWorking",
	"save",
	"delete",
	"setField",
	"add",
	"remove",
	"close",
	"update",
	"error"
]);

export default DocumentActions;
